import ArrayProxy from "@ember/array/proxy"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import _ from "lodash"
import { all } from "rsvp"

export default function embeddedHasMany(modelName, keyName, relationshipType) {
  return computed(`${modelName}.${keyName}.[]`, function () {
    var ObjectPromiseProxy = ArrayProxy.extend(PromiseProxyMixin)
    let ids = get(this, `${modelName}.${keyName}`)
    return ObjectPromiseProxy.create({
      promise: all(_.map(ids, (id) => get(this, "store").find(relationshipType, id))),
    })
  })
}
